import { Container, Image } from 'react-bootstrap'

const RevealMostDiets = () => (
    <>
    <div className="section-reveal text-center text-white">
        <Image src="../images/7bs/img-hungry01.png" alt="Learn Why Carbs Are Ok" className="img-fluid d-block mx-auto"/>
        <div className="strip">
            <Container>
                <p>We'll reveal why most diets leave you feeling hungry <br/>
                    <small>and what to do about it</small></p>
            </Container>
        </div>
    </div>
    <style jsx global>{`

            .section-reveal {
                background: #fff;
            }

            .section-reveal img {
                margin-bottom: -100px;
            }

            .section-reveal .strip {
                background: #de7621;
                padding-top: 120px;
                padding-bottom: 40px;
            }

            .section-reveal p {
                font-size: 40px;
                line-height: 40px;
            }

            @media (max-width: 767.98px) {

                .section-reveal p {
                    font-size: 30px;
                }

            }

        `}</style>
    </>
);

export default RevealMostDiets;